import { Action } from '@ngrx/store';
import { IPaymentCheckFormCC, IPaymentCheckFormExt } from 'src/commons';


export enum PaymentCheckActionTypes {

  LoadFormCCForValidateInvoiveState = '[PaymentCheck] Load FormCCForValidateInvoive State',
  LoadFormCCForValidateInvoiveStateSuccess = '[PaymentCheck] Load FormCCForValidateInvoive State Success',
  ValidateFormCC = '[PaymentCheck] Validate FormCC for Invoice',
  LoadFormCCForUploadState = '[PaymentCheck] Load FormCCForUpload State',
  LoadFormCCForUploadStateSuccess = '[PaymentCheck] Load FormCCForUpload State Success',
  SendToOeBSFormCC = '[PaymentCheck] Send FormCC to OeBS',
  LoadFormCCSentToOeBSState = '[PaymentCheck] Load FormCCSentToOeBS State',
  LoadFormCCSentToOeBSStateSuccess = '[PaymentCheck] Load FormCCSentToOeBS State Success',
  LoadFormCCForControlReportState = '[PaymentCheck] Load FormCCForControlReport State Success',
  GenerateControlReportFormCC = '[PaymentCheck] Generate ControlReport FormCC',

  LoadFormCGForValidateInvoiveState = '[PaymentCheck] Load FormCGForValidateInvoive State',
  LoadFormCGForValidateInvoiveStateSuccess = '[PaymentCheck] Load FormCGForValidateInvoive State Success',
  ValidateFormCG = '[PaymentCheck] Validate FormCG for Invoice',
  LoadFormCGForUploadState = '[PaymentCheck] Load FormCGForUpload State',
  LoadFormCGForUploadStateSuccess = '[PaymentCheck] Load FormCGForUpload State Success',
  SendToOeBSFormCG = '[PaymentCheck] Send FormCG to OeBS',
  LoadFormCGSentToOeBSState = '[PaymentCheck] Load FormCGSentToOeBS State',
  LoadFormCGSentToOeBSStateSuccess = '[PaymentCheck] Load FormCGSentToOeBS State Success',
  LoadFormCGForControlReportState = '[PaymentCheck] Load FormCGForControlReport State Success',
  GenerateControlReportFormCG = '[PaymentCheck] Generate ControlReport FormCG',

  LoadFormPPForValidateInvoiveState = '[PaymentCheck] Load FormPPForValidateInvoive State',
  LoadFormPPForValidateInvoiveStateSuccess = '[PaymentCheck] Load FormPPForValidateInvoive State Success',
  ValidateFormPP = '[PaymentCheck] Validate FormPP for Invoice',
  LoadFormPPForUploadState = '[PaymentCheck] Load FormPPForUpload State',
  LoadFormPPForUploadStateSuccess = '[PaymentCheck] Load FormPPForUpload State Success',
  SendToOeBSFormPP = '[PaymentCheck] Send FormPP to OeBS',
  LoadFormPPSentToOeBSState = '[PaymentCheck] Load FormPPSentToOeBS State',
  LoadFormPPSentToOeBSStateSuccess = '[PaymentCheck] Load FormPPSentToOeBS State Success',
  LoadFormPPForControlReportState = '[PaymentCheck] Load FormPPForControlReport State Success',
  GenerateControlReportFormPP = '[PaymentCheck] Generate ControlReport FormPP',

  LoadFormESForValidateInvoiveState = '[PaymentCheck] Load FormESForValidateInvoive State',
  LoadFormESForValidateInvoiveStateSuccess = '[PaymentCheck] Load FormESForValidateInvoive State Success',
  ValidateFormES = '[PaymentCheck] Validate FormES for Invoice',
  LoadFormESForUploadState = '[PaymentCheck] Load FormESForUpload State',
  LoadFormESForUploadStateSuccess = '[PaymentCheck] Load FormESForUpload State Success',
  SendToOeBSFormES = '[PaymentCheck] Send FormES to OeBS',
  LoadFormESSentToOeBSState = '[PaymentCheck] Load FormESSentToOeBS State',
  LoadFormESSentToOeBSStateSuccess = '[PaymentCheck] Load FormESSentToOeBS State Success',
  LoadFormESForControlReportState = '[PaymentCheck] Load FormESForControlReport State Success',
  GenerateControlReportFormES = '[PaymentCheck] Generate ControlReport FormES',

  LoadInitPaymentCheckState = '[PaymentCheck] Load Initial PaymentCheck State',
  LoadPaymentCheckStateFail = '[PaymentCheck] Load PaymentCheck State Fail',
  ValidateFail = '[PaymentCheck] Validate to OeBS Fail',
  UploadFail = '[PaymentCheck] Upload to OeBS Fail',
  PaymentCheckScreenErrorReset = '[PaymentCheck] PaymentCheck Screen Error Reset'

  // LoadFormCIForValidateInvoiveState = '[PaymentCheck] Load FormCIForValidateInvoive State',
  // LoadFormCIForValidateInvoiveStateSuccess = '[PaymentCheck] Load FormCIForValidateInvoive State Success',
  // ValidateFormCI = '[PaymentCheck] Validate FormCI for Invoice',
  // LoadFormCIForUploadState = '[PaymentCheck] Load FormCIForUpload State',
  // LoadFormCIForUploadStateSuccess = '[PaymentCheck] Load FormCIForUpload State Success',
  // SendToOeBSFormCI = '[PaymentCheck] Send FormCI to OeBS',
  // LoadFormCISentToOeBSState = '[PaymentCheck] Load FormCISentToOeBS State',
  // LoadFormCISentToOeBSStateSuccess = '[PaymentCheck] Load FormCISentToOeBS State Success',
  // LoadFormCIForControlReportState = '[PaymentCheck] Load FormCIForControlReport State Success',
  // GenerateControlReportFormCI = '[PaymentCheck] Generate ControlReport FormCI',

}

// formCC
export class LoadFormCCForValidateInvoiveState implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormCCForValidateInvoiveState;
}

export class LoadFormCCForValidateInvoiveStateSuccess implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormCCForValidateInvoiveStateSuccess;
  constructor(public payload: IPaymentCheckFormCC) { }
}

export class ValidateFormCC implements Action {
  readonly type = PaymentCheckActionTypes.ValidateFormCC;
  constructor(public data: any) { }
}

export class LoadFormCCForUploadState implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormCCForUploadState;
}

export class LoadFormCCForUploadStateSuccess implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormCCForUploadStateSuccess;
  constructor(public payload: IPaymentCheckFormCC) { }
}

export class SendToOeBSFormCC implements Action {
  readonly type = PaymentCheckActionTypes.SendToOeBSFormCC;
  constructor(public data: any) { }
}

export class LoadFormCCSentToOeBSState implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormCCSentToOeBSState;
}

export class LoadFormCCSentToOeBSStateSuccess implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormCCSentToOeBSStateSuccess;
  constructor(public payload: IPaymentCheckFormCC) { }
}

export class LoadFormCCForControlReportState implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormCCForControlReportState;
}

export class GenerateControlReportFormCC implements Action {
  readonly type = PaymentCheckActionTypes.GenerateControlReportFormCC;
  constructor(public data: any) { }
}

// formCG
export class LoadFormCGForValidateInvoiveState implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormCGForValidateInvoiveState;
}

export class LoadFormCGForValidateInvoiveStateSuccess implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormCGForValidateInvoiveStateSuccess;
  constructor(public payload: IPaymentCheckFormExt) { }
}

export class ValidateFormCG implements Action {
  readonly type = PaymentCheckActionTypes.ValidateFormCG;
  constructor(public data: any) { }
}

export class LoadFormCGForUploadState implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormCGForUploadState;
}

export class LoadFormCGForUploadStateSuccess implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormCGForUploadStateSuccess;
  constructor(public payload: IPaymentCheckFormExt) { }
}

export class SendToOeBSFormCG implements Action {
  readonly type = PaymentCheckActionTypes.SendToOeBSFormCG;
  constructor(public data: any) { }
}

export class LoadFormCGSentToOeBSState implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormCGSentToOeBSState;
}

export class LoadFormCGSentToOeBSStateSuccess implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormCGSentToOeBSStateSuccess;
  constructor(public payload: IPaymentCheckFormExt) { }
}

export class LoadFormCGForControlReportState implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormCGForControlReportState;
}

export class GenerateControlReportFormCG implements Action {
  readonly type = PaymentCheckActionTypes.GenerateControlReportFormCG;
  constructor(public data: any) { }
}

// formPP
export class LoadFormPPForValidateInvoiveState implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormPPForValidateInvoiveState;
}

export class LoadFormPPForValidateInvoiveStateSuccess implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormPPForValidateInvoiveStateSuccess;
  constructor(public payload: IPaymentCheckFormExt) { }
}

export class ValidateFormPP implements Action {
  readonly type = PaymentCheckActionTypes.ValidateFormPP;
  constructor(public data: any) { }
}

export class LoadFormPPForUploadState implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormPPForUploadState;
}

export class LoadFormPPForUploadStateSuccess implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormPPForUploadStateSuccess;
  constructor(public payload: IPaymentCheckFormExt) { }
}

export class SendToOeBSFormPP implements Action {
  readonly type = PaymentCheckActionTypes.SendToOeBSFormPP;
  constructor(public data: any) { }
}

export class LoadFormPPSentToOeBSState implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormPPSentToOeBSState;
}

export class LoadFormPPSentToOeBSStateSuccess implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormPPSentToOeBSStateSuccess;
  constructor(public payload: IPaymentCheckFormExt) { }
}

export class LoadFormPPForControlReportState implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormPPForControlReportState;
}

export class GenerateControlReportFormPP implements Action {
  readonly type = PaymentCheckActionTypes.GenerateControlReportFormPP;
  constructor(public data: any) { }
}

// formES
export class LoadFormESForValidateInvoiveState implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormESForValidateInvoiveState;
}

export class LoadFormESForValidateInvoiveStateSuccess implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormESForValidateInvoiveStateSuccess;
  constructor(public payload: IPaymentCheckFormExt) { }
}

export class ValidateFormES implements Action {
  readonly type = PaymentCheckActionTypes.ValidateFormES;
  constructor(public data: any) { }
}

export class LoadFormESForUploadState implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormESForUploadState;
}

export class LoadFormESForUploadStateSuccess implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormESForUploadStateSuccess;
  constructor(public payload: IPaymentCheckFormExt) { }
}

export class SendToOeBSFormES implements Action {
  readonly type = PaymentCheckActionTypes.SendToOeBSFormES;
  constructor(public data: any) { }
}

export class LoadFormESSentToOeBSState implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormESSentToOeBSState;
}

export class LoadFormESSentToOeBSStateSuccess implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormESSentToOeBSStateSuccess;
  constructor(public payload: IPaymentCheckFormExt) { }
}

export class LoadFormESForControlReportState implements Action {
  readonly type = PaymentCheckActionTypes.LoadFormESForControlReportState;
}

export class GenerateControlReportFormES implements Action {
  readonly type = PaymentCheckActionTypes.GenerateControlReportFormES;
  constructor(public data: any) { }
}

// other
export class LoadInitPaymentCheckState implements Action {
  readonly type = PaymentCheckActionTypes.LoadInitPaymentCheckState;
}

export class LoadPaymentCheckStateFail implements Action {
  readonly type = PaymentCheckActionTypes.LoadPaymentCheckStateFail;
  constructor(public payload: any) { }
}

export class ValidateFail implements Action {
  readonly type = PaymentCheckActionTypes.ValidateFail;
  constructor(public payload: any, public formName: any) { }
}

export class UploadFail implements Action {
  readonly type = PaymentCheckActionTypes.UploadFail;
  constructor(public payload: any, public formName: string) { }
}

export class PaymentCheckScreenErrorReset implements Action {
  readonly type = PaymentCheckActionTypes.PaymentCheckScreenErrorReset;
}

export type PaymentCheckActions =
  LoadFormCCForValidateInvoiveState
  | LoadFormCCForValidateInvoiveStateSuccess
  | ValidateFormCC
  | LoadFormCCForUploadState
  | LoadFormCCForUploadStateSuccess
  | SendToOeBSFormCC
  | LoadFormCCSentToOeBSState
  | LoadFormCCSentToOeBSStateSuccess
  | LoadFormCCForControlReportState
  | GenerateControlReportFormCC

  | LoadFormCGForValidateInvoiveState
  | LoadFormCGForValidateInvoiveStateSuccess
  | ValidateFormCG
  | LoadFormCGForUploadState
  | LoadFormCGForUploadStateSuccess
  | SendToOeBSFormCG
  | LoadFormCGSentToOeBSState
  | LoadFormCGSentToOeBSStateSuccess
  | LoadFormCGForControlReportState
  | GenerateControlReportFormCG

  | LoadFormPPForValidateInvoiveState
  | LoadFormPPForValidateInvoiveStateSuccess
  | ValidateFormPP
  | LoadFormPPForUploadState
  | LoadFormPPForUploadStateSuccess
  | SendToOeBSFormPP
  | LoadFormPPSentToOeBSState
  | LoadFormPPSentToOeBSStateSuccess
  | LoadFormPPForControlReportState
  | GenerateControlReportFormPP

  | LoadFormESForValidateInvoiveState
  | LoadFormESForValidateInvoiveStateSuccess
  | ValidateFormES
  | LoadFormESForUploadState
  | LoadFormESForUploadStateSuccess
  | SendToOeBSFormES
  | LoadFormESSentToOeBSState
  | LoadFormESSentToOeBSStateSuccess
  | LoadFormESForControlReportState
  | GenerateControlReportFormES

  | LoadInitPaymentCheckState
  | LoadPaymentCheckStateFail
  | UploadFail
  | ValidateFail
  | PaymentCheckScreenErrorReset;





  // | LoadFormCIForValidateInvoiveState
  // | LoadFormCIForValidateInvoiveStateSuccess
  // | ValidateFormCI
  // | LoadFormCIForUploadState
  // | LoadFormCIForUploadStateSuccess
  // | SendToOeBSFormCI
  // | LoadFormCISentToOeBSState
  // | LoadFormCISentToOeBSStateSuccess
  // | LoadFormCIForControlReportState
  // | GenerateControlReportFormCI







// export class LoadFormCIForValidateInvoiveState implements Action {
//   readonly type = PaymentCheckActionTypes.LoadFormCIForValidateInvoiveState;
// }

// export class LoadFormCIForValidateInvoiveStateSuccess implements Action {
//   readonly type = PaymentCheckActionTypes.LoadFormCIForValidateInvoiveStateSuccess;
//   constructor(public payload: IPaymentCheckFormExt) { }
// }

// export class ValidateFormCI implements Action {
//   readonly type = PaymentCheckActionTypes.ValidateFormCI;
//   constructor(public data: any) { }
// }

// export class LoadFormCIForUploadState implements Action {
//   readonly type = PaymentCheckActionTypes.LoadFormCIForUploadState;
// }

// export class LoadFormCIForUploadStateSuccess implements Action {
//   readonly type = PaymentCheckActionTypes.LoadFormCIForUploadStateSuccess;
//   constructor(public payload: IPaymentCheckFormExt) { }
// }

// export class SendToOeBSFormCI implements Action {
//   readonly type = PaymentCheckActionTypes.SendToOeBSFormCI;
//   constructor(public data: any) { }
// }

// export class LoadFormCISentToOeBSState implements Action {
//   readonly type = PaymentCheckActionTypes.LoadFormCISentToOeBSState;
// }

// export class LoadFormCISentToOeBSStateSuccess implements Action {
//   readonly type = PaymentCheckActionTypes.LoadFormCISentToOeBSStateSuccess;
//   constructor(public payload: IPaymentCheckFormExt) { }
// }

// export class LoadFormCIForControlReportState implements Action {
//   readonly type = PaymentCheckActionTypes.LoadFormCIForControlReportState;
// }

// export class GenerateControlReportFormCI implements Action {
//   readonly type = PaymentCheckActionTypes.GenerateControlReportFormCI;
//   constructor(public data: any) { }
// }


